module.exports = __webpack_public_path__ + "static/media/Public_05.a21778c1.jpg";